import React from 'react';
import Container from '@mui/material/Container';
import { Grid, Box, Typography, ListItem, List, Link as MuiLink, Stack, Skeleton, Divider } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';

import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import { Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { mockProductsData } from '../../../mock/productsData';

const FooterMobile = () => {
  const location = useLocation();
  const allProducts = mockProductsData;
  const loading = false;
  const numberOfSkeletons = 4;
  // Function to open Google Maps

  const openMap = () => {
    window.open('https://maps.app.goo.gl/WR7YGzpGV4xfZ8nG6?g_st=com.google.maps.preview.copy');
  };
  const footerItemsMobile = [
    {
      itemName: 'Estimate',
      pathName: '/estimate#estimate_top',
      activeImage: '/assets/images/Footer/Orrange_estimate.png',
      inActiveImage: '/assets/images/Footer/Grey_estimate.png',
      alt: '1',
    },
    {
      itemName: 'Booking',
      pathName: '/booking#booking_top',
      activeImage: '/assets/images/Footer/Orrange_home.png',
      inActiveImage: '/assets/images/Footer/Grey_home.png',
      alt: '2',
    },
  ];
  // console.log(location?.pathname);
  return (
    <Box px="4px" sx={{ backgroundColor: '#F0F0F0', pt: 3, pb: 3, position: 'relative', zIndex: 2 }}>
      <Container maxWidth="xl">
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={12} sm={4} md={2}>
            <Link to="/estimate" component={Link} sx={{ display: 'contents' }}>
              <img src="/assets/logoFooter.png" alt="Zeal Curtains" style={{ height: 58 }} />
            </Link>
          </Grid>
          <Grid item xs={12}>
            {' '}
            <Divider sx={{ borderColor: '#E0E0E0', mt: 2 }} />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Stack direction="row" gap={12}>
              <List sx={{ pt: '0 !important' }}>
                <ListItem disableGutters sx={{ pt: '0px !important' }}>
                  <HashLink
                    smooth
                    to="/estimate#estimate_top"
                    className="merri-weather-text-lighter"
                    style={{ textDecoration: 'none', color: '#1D1D1DDE', fontSize: '13px' }}
                  >
                    Estimate
                  </HashLink>
                </ListItem>
                <ListItem disableGutters>
                  <HashLink
                    smooth
                    to="/booking#booking_top"
                    className="merri-weather-text-lighter"
                    style={{ textDecoration: 'none', color: '#1D1D1DDE', fontSize: '13px' }}
                  >
                    Booking
                  </HashLink>
                </ListItem>
              </List>

              <List sx={{ pt: '0 !important' }}>
                {loading
                  ? // Show skeletons when loading
                    Array.from(new Array(numberOfSkeletons)).map((_, index) => (
                      <ListItem
                        disableGutters
                        key={index}
                        sx={{
                          fontSize: '13px',
                          color: '#322B2B',

                          mb: 1,
                        }}
                      >
                        <Skeleton variant="text" width="4rem" height="1em" animation="wave" />
                      </ListItem>
                    ))
                  : allProducts?.products?.slice(0, 4).map((product, key) => (
                      <ListItem
                        className="merri-weather-text-lighter"
                        disableGutters
                        key={product.id || key}
                        sx={{ fontSize: '13px', color: '#1D1D1DDE', pt: '0px !important', cursor: 'pointer' }}
                      >
                        <HashLink
                          smooth
                          to="/estimate#estimate_top"
                          state={product?._id}
                          key={key}
                          style={{ textDecoration: 'none', color: '#1D1D1DDE' }}
                        >
                          {product.name}
                        </HashLink>
                      </ListItem>
                    ))}
              </List>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            {' '}
            <Divider sx={{ borderColor: '#E0E0E0', mt: 2 }} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Stack direction="row" gap={2}>
              <Typography
                sx={{ fontSize: '14px', color: '#322B2B' }}
                className="merri-weather-text-lighter"
                mb={1}
                minWidth="120px"
              >
                Follow us on
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                <MuiLink href="http://www.instagram.com/zealcurtains" target="_blank" rel="noopener" color="inherit">
                  <InstagramIcon sx={{ color: '#322B2B', height: '20px' }} />
                </MuiLink>
                <MuiLink href="http://www.facebook.com/zealcurtains" target="_blank" rel="noopener" color="inherit">
                  <FacebookRoundedIcon sx={{ color: '#322B2B', height: '20px' }} />
                </MuiLink>
              </Box>
            </Stack>
            <Stack direction="row" gap={2}>
              <Typography
                sx={{ fontSize: '14px', color: '#322B2B' }}
                className="merri-weather-text-lighter"
                mb={1}
                minWidth="120px"
              >
                Call us on
              </Typography>
              <Typography
                color="#322B2B"
                variant="body2"
                mb={0.5}
                sx={{ textDecoration: 'underline', letterSpacing: '1px' }}
              >
                +971 58 549 0727
              </Typography>
            </Stack>
            <Stack direction="row" gap={2} mb="122px">
              <Typography
                sx={{ fontSize: '14px', color: '#322B2B' }}
                className="merri-weather-text-lighter"
                mb={1}
                minWidth="120px"
              >
                Visit us in
              </Typography>
              <Typography
                sx={{ fontSize: '13px', color: '#322B2B' }}
                className="merri-weather-text-lighter"
                onClick={openMap}
              >
                <strong className="merri-weather-text-bold">Dubai</strong>
                <br />
                AL KHABAEESI BUILDING,
                <br />
                PLOT NO. 285-0, Makani No. 3229195132, office no.
                <br />
                18-64, Dubai, UAE.
              </Typography>
            </Stack>
          </Grid>
        </Grid>


      </Container>
      <Grid
        container
        spacing={1}
        sx={{
          padding: '0rem 1rem 1rem 1rem',
          display: { sx: 'flex', sm: 'none' },
          flexDirection: { sx: 'row' },
          position: 'fixed',
          bottom: 0,
          backgroundColor: 'white',
          zIndex: 12,
        }}
      >
        {footerItemsMobile?.map((item, key) => (
          <Grid key={key} item xs={3} sm={6} md={3} lg={3}>
            {/* <Link to={item?.pathName} style={{ textDecoration: 'none' }}> */}
            <HashLink smooth to={item?.pathName} key={key} style={{ textDecoration: 'none' }}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'column' }, alignItems: 'center' }}>
                {location?.pathname === item?.pathName ? (
                  <img
                    src={item?.activeImage}
                    alt={item?.alt}
                    style={{
                      width: '20px',
                      height: '33px',
                      objectFit: 'scale-down',
                    }}
                  />
                ) : (
                  <img
                    src={item?.inActiveImage}
                    alt={item?.alt}
                    style={{
                      width: '20px',
                      height: '33px',
                      objectFit: 'scale-down',
                    }}
                  />
                )}
                <Stack alignItems="center" spacing={0.5}>
                  <Typography
                    sx={{
                      textAlign: 'center',
                      fontWeight: location?.pathname === item?.pathName.split('#')[0] ? '700' : '400',
                      color: location?.pathname === item?.pathName.split('#')[0] ? '#ec2927' : 'black',
                      fontSize: '12px',
                    }}
                  >
                    {item?.itemName}
                  </Typography>

                  {location?.pathname === item?.pathName.split('#')[0] && (
                    <Box
                      sx={{
                        width: '100%',
                        height: '2px',
                        backgroundColor: '#ec2927',
                        borderRadius: 1,
                        mt: '2px',
                      }}
                    />
                  )}
                </Stack>
              </Box>
            </HashLink>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FooterMobile;
